export default __webpack_public_path__ + "static/iso-5d827f39e704005f737e079c2de90a41.png";